module.exports = __webpack_public_path__ + "img/music_004.059097e7.png";